import React, { memo } from "react";

const SideButtons = () => null;

export default memo(SideButtons);